import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import ContactForm from '../components/ContactForm';
import { Helmet } from 'react-helmet-async';
import './MusicianProfile.css';

export default function TeacherProfile() {
  const { id } = useParams();
  const [teacher, setTeacher] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTeacher = async () => {
      const docRef = doc(db, 'teachers', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setTeacher({ id: docSnap.id, ...docSnap.data() });
      }
    };
    fetchTeacher();
  }, [id]);

  if (!teacher) {
    return <p style={{ color: 'white', textAlign: 'center' }}>Chargement...</p>;
  }

  return (
    <div className="musician-profile-container animated-fade-in">
      <Helmet>
        <title>{`${teacher.name} | Professeur à réserver`}</title>
        <meta
          name="description"
          content={`Réservez ${teacher.name}, professeur de ${teacher.subject} basé à ${teacher.city}. Découvrez son profil et ses compétences.`}
        />
        <meta property="og:title" content={`${teacher.name} | Professeur à réserver`} />
        <meta
          property="og:description"
          content={`Réservez ${teacher.name}, professeur de ${teacher.subject} disponible à ${teacher.city}.`}
        />
        {teacher.imageURL && <meta property="og:image" content={teacher.imageURL} />}
        <link rel="canonical" href={`https://www.gatesofmusic.com/teachers/${teacher.id}`} />
        <meta property="og:type" content="profile" />
        <meta property="og:url" content={`https://www.gatesofmusic.com/teachers/${teacher.id}`} />
      </Helmet>

      <div className="musician-profile-card">
        <img
          src={teacher.imageURL ? `/images/teachers/${teacher.imageURL}` : '/default-profile.png'}
          alt={teacher.name}
          className="musician-profile-image"
        />
        <div className="musician-profile-info">
          <h1 className="musician-profile-name">{teacher.name}</h1>
          <p><strong>Matière :</strong> {teacher.subject}</p>
          <p><strong>Ville :</strong> {teacher.city}</p>

          {teacher.bio && (
            <div className="musician-profile-bio-block">
              <h3 className="musician-profile-bio-title">À propos</h3>
              <p className="musician-profile-bio-text">{teacher.bio}</p>
            </div>
          )}
        </div>
      </div>

      <div className="musician-profile-bottom">
        <ContactForm teacherName={teacher.name} />
        <button
          className="musician-profile-back-button"
          onClick={() => navigate('/')}
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
}
